import { render, staticRenderFns } from "./ReturnView.vue?vue&type=template&id=b1ddbc48&scoped=true"
import script from "./ReturnView.vue?vue&type=script&lang=js"
export * from "./ReturnView.vue?vue&type=script&lang=js"
import style0 from "./ReturnView.vue?vue&type=style&index=0&id=b1ddbc48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ddbc48",
  null
  
)

export default component.exports